import { Component, effect, inject } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { EnumService } from '@lib-services/enum.service';
import { MatTooltip } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { TimeZoneService } from '@lib-services/time-zone.service';
import { TimeZoneEnum } from '@libs-enums/time-zone.enum';
import { SessionStorageService } from '@lib-services/session-storage.service';

@Component({
    selector: 'app-time-zone',
    standalone: true,
    imports: [
        MatFormField,
        MatLabel,
        MatOption,
        MatSelect,
        MatTooltip,
        FormsModule,
    ],
    templateUrl: './time-zone.component.html',
    styleUrl: './time-zone.component.scss'
})
export class TimeZoneComponent {
    protected enumService = inject(EnumService);
    protected timeZoneService = inject(TimeZoneService);
    protected sessionStorageService = inject(SessionStorageService);
    protected readonly TimeZoneEnum = TimeZoneEnum;

    constructor() {
        effect(() => {
            if (this.timeZoneService.currentTimeZone()) {
                this.sessionStorageService.setItem('time-zone', this.timeZoneService.currentTimeZone());
            }
        });
    }
}
